import React, {Component} from 'react';
import BaseLayout from '../../templates/base';
import {AUTH_URL} from '../../store/config';

class Welcome extends Component {
	render() {
		return (
			<div className="columns is-centered is-multiline">
				<div className="column is-10">
					<div className="content">
						<h1 className="title is-2 has-text-inm-purple"><strong>Documentos de ayuda</strong></h1>
						<br/>
						<p>
							<a target="_blank" href={`${AUTH_URL}/storage/documentos-apoyo/ayuda/Acuerdo_montos_ROP_2019.pdf`}>
								<i style={{marginRight: '10px'}} className="fa fa-file-pdf-o fa-lg"/>
								<span>Acuerdo ROP</span>
							</a>
						</p>
						<p>
							<a target="_blank" href={`${AUTH_URL}/storage/documentos-apoyo/ayuda/2019_02_19_MAT_inm.pdf`}>
								<i style={{marginRight: '10px'}} className="fa fa-file-pdf-o fa-lg"/>
								<span>ROP DOF 261217</span>
							</a>
						</p>
						<p>
							<a target="_blank" href={`${AUTH_URL}/storage/documentos-apoyo/ayuda/Formato_tramite_reintegro_recurso_PFTPG.xlsx`}>
								<i style={{marginRight: '10px'}} className="fa fa-file-excel-o fa-lg"/>
								<span>Formato de tramite de reintegro de recurso PFTPG</span>
							</a>
						</p>
						<p>
							<a target="_blank" href={`${AUTH_URL}/storage/documentos-apoyo/ayuda/Instructivo_registro_proyecto_19.pdf`}>
								<i style={{marginRight: '10px'}} className="fa fa-file-pdf-o fa-lg" />
								<span>Instructivo etransversalidad 2018 VCG VF</span>
							</a>
						</p>
						<p>
							<a href={`${AUTH_URL}/storage/documentos-apoyo/ayuda/plataforma_e-transversalidad.pptx`} target="_blank">
								<i style={{marginRight: '10px'}} className="fa fa-file-powerpoint-o fa-lg" />
								Plataforma e-Transversalidad
							</a>
						</p>
					</div>
				</div>
			</div>
		);
	}
}

export default BaseLayout(Welcome);


// WEBPACK FOOTER //
// ./src/layouts/helps/index.jsx